import { HttpBackend, HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TableauService {
  private http: HttpClient;
  handler = inject(HttpBackend);

  private _baseUrl = '/api/tableau';

  constructor() {
    // Setting up HttpClient this way allows us to bypass the Cache HttpInterceptor
    this.http = new HttpClient(this.handler);
  }

  getReportByInstId(tsPath: string, instIds: number[]) {
    return this.http.get<{ url: string }>(
      `${this._baseUrl}/reports?tsPath=${tsPath}&instIds=${instIds.join(',')}`,
    );
  }

  getReportByUnit(tsPath: string, instIds: number[], unitId: number) {
    return this.http.get<{ url: string }>(
      `${this._baseUrl}/reports?tsPath=${tsPath}&instIds=${instIds.join(',')}&unitId=${unitId}`,
    );
  }
}
